export const AUTH_UNKNOWN = 'AUTH_UNKNOWN';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';



// WEBPACK FOOTER //
// ./src/redux/sagas/aws-cognito-redux-saga/states.js